/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BucketObject { 
    /**
     * Bucket objects
     */
    object_name?: string;
    /**
     * Last modified that.
     */
    last_modified_date?: Date;
}

